"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonMotion = void 0;
var _designTokens = require("@smartsheet/design-tokens");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const motionTheme = (0, _sdsThemeInternal.themed)({
  "lodestar-light": "",
  "ursa-light": `all ${_designTokens.motion.animation.default}`
});
const getButtonMotion = _ref => {
  let {
    themeMode
  } = _ref;
  return motionTheme(themeMode);
};
exports.getButtonMotion = getButtonMotion;
//# sourceMappingURL=getButtonMotion.js.map